// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__312KR","info":"PatientInfo_info__1Asr8"};